import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowClockwiseFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowClockwiseFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M18.5 13.25v.5c0 3.58-2.92 6.5-6.5 6.5s-6.5-2.92-6.5-6.5 2.92-6.5 6.5-6.5h1.08l-2.5 3.5h3.69l3.57-5-3.57-5h-3.69l2.5 3.5H12c-5.24 0-9.5 4.26-9.5 9.5s4.26 9.5 9.5 9.5 9.5-4.26 9.5-9.5v-.5h-3Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowClockwiseFilled;